// extracted by mini-css-extract-plugin
module.exports = {"Container":"OpenInRiveCommunityButton_Container__20R4I","Icon":"OpenInRiveCommunityButton_Icon__k3giv"};